module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_decesos.2ce36525.jpg";